<template>
	<div>
		<p class="text-sm text-text-secondary">{{ label }}</p>
		<p
			v-if="value !== null && value !== undefined"
			class="-mt-1 whitespace-pre-wrap"
		>
			{{ value }}
		</p>
	</div>
</template>

<script lang="ts" setup>
interface Props {
	label: string;
	value?: string | null;
}
defineProps<Props>();
</script>
